export default {
    key: 'eigergletscher',
    common: {
        productName: 'core.productNames.eigergletscher',
        splashMessage: 'offerFlow.splashMessage.eigergletscher',
        headingAside: 'offerFlow.headingAside.eigergletscher',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.eigergletscher',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
